import React from "react";

function SelectorCard({ title, description, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="rounded-3xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md dark:border-slate-800 dark:bg-slate-950"
        >
            <p className="text-base font-semibold text-slate-900 dark:text-white">
                {title}
            </p>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                {description}
            </p>
        </button>
    );
}

export default function ConsultationTypeSelector({
    showingSubtypes,
    typeOptions,
    subtypeOptions,
    onSelectType,
    onSelectSubtype,
    onBack,
}) {
    return (
        <div className="flex flex-1 items-center justify-center px-4 py-10 lg:px-6 lg:py-16">
            <div className="w-full max-w-4xl rounded-[28px] border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-sky-50 p-5 shadow-sm dark:border-slate-800 dark:from-slate-950 dark:via-slate-900 dark:to-slate-900 sm:p-8">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500 dark:text-slate-400">
                            Inicio de consulta
                        </p>
                        <h1 className="mt-1 text-2xl font-semibold text-slate-900 dark:text-white">
                            {showingSubtypes
                                ? "Selecciona el motivo principal"
                                : "Selecciona el tipo de consulta"}
                        </h1>
                        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                            Primero elegimos la categoria y luego el subtipo para preparar el formulario adecuado.
                        </p>
                    </div>
                    {showingSubtypes && (
                        <button
                            type="button"
                            onClick={onBack}
                            className="inline-flex h-11 items-center justify-center rounded-2xl border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm transition hover:border-primary/40 hover:text-primary dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
                        >
                            Cambiar categoria
                        </button>
                    )}
                </div>

                <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                    {(showingSubtypes ? subtypeOptions : typeOptions).map((option) => (
                        <SelectorCard
                            key={option.value}
                            title={option.name}
                            description={
                                showingSubtypes
                                    ? "Abrir formulario de consulta con este enfoque."
                                    : "Define el flujo general y las opciones disponibles."
                            }
                            onClick={() =>
                                showingSubtypes
                                    ? onSelectSubtype(option.value)
                                    : onSelectType(option.value)
                            }
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
